/* eslint-disable */
import axios from "axios";
import router from "@/router";

export const base = process.env.VUE_APP_BASE_URL;
export const authUrl = base;
export const simitrack = base + "/simitrack/index.php";
export const uploads = base + "/simitrack/uploads/";

// ===== AXIOS 401 INTERCEPTOR — handles session expiry globally =====
let sessionExpiredShown = false;

axios.interceptors.response.use(
    (response) => {
        // Check for session expired in response body (API sometimes returns 200 with expired message)
        if (response.data && response.data.success === false && response.data.message === "Your session has expired.") {
            handleSessionExpired();
            return Promise.reject(new Error("Session expired"));
        }
        return response;
    },
    (error) => {
        if (error.response && error.response.status === 401) {
            handleSessionExpired();
            return Promise.reject(error);
        }
        return Promise.reject(error);
    }
);

function handleSessionExpired() {
    if (sessionExpiredShown) return;
    sessionExpiredShown = true;

    alert("Your session has expired. Please log in again.");

    // Clear auth data
    localStorage.removeItem("authToken");
    sessionStorage.removeItem("isLoggedIn");
    sessionStorage.removeItem("userRole");
    sessionStorage.removeItem("userName");
    sessionStorage.removeItem("institutionName");
    sessionStorage.removeItem("institutionId");
    sessionStorage.removeItem("token");

    // Redirect to login
    router.push("/login");

    // Reset flag after redirect so it can fire again on next session
    setTimeout(() => { sessionExpiredShown = false; }, 2000);
}
// ===== END INTERCEPTOR =====

export const execute = (params, url) => {
    const tokenStr = localStorage.getItem("authToken");
    return axios.post(url, params, { headers: { "Authorization": `Bearer ${tokenStr}` } });
};

export const executeJson = (params, url) => {
    const tokenStr = localStorage.getItem("authToken");
    return axios.post(url, params, {
        headers: {
            "Authorization": `Bearer ${tokenStr}`,
            "Content-Type": "application/json"
        }
    });
};

export const executeDownload = (params, url) => {
    const tokenStr = localStorage.getItem("authToken");
    return axios.post(url, params, { headers: { "Authorization": `Bearer ${tokenStr}` }, responseType: 'blob' });
};

export const getRight = (accessRole) => {
    const rolesStr = sessionStorage.getItem("userRole");
    if (!rolesStr) return false;
    return rolesStr === accessRole;
};